import React from 'react';
import { Box, Text, HStack, VStack, Avatar } from '@chakra-ui/react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  rating: number;
  text: string;
  author: string;
  location: string;
  verified?: boolean;
  avatarUrl?: string;
}
export function TestimonialCard({
  rating,
  text,
  author,
  location,
  verified = true,
  avatarUrl
}: TestimonialCardProps) {
  return <Box bg="rgba(0, 0, 0, 0.6)" p={6} borderRadius="xl" shadow="2xl" borderWidth="2px" borderColor="red.800" _hover={{
    shadow: '2xl',
    transform: 'translateY(-2px)',
    borderColor: 'red.600'
  }} transition="all 0.2s" data-id="element-248">
      <VStack align="stretch" spacing={4} data-id="element-249">
        <HStack spacing={1} data-id="element-250">
          {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill={i < rating ? '#F59E0B' : 'none'} stroke={i < rating ? '#F59E0B' : '#4B5563'} strokeWidth={2} data-id="element-251" />)}
        </HStack>

        <Text color="gray.300" fontSize="md" lineHeight="tall" data-id="element-252">
          "{text}"
        </Text>

        <HStack spacing={3} align="center" data-id="element-253">
          <Avatar src={avatarUrl} name={author} size="md" borderWidth="2px" borderColor="red.500" data-id="element-254" />
          <Box data-id="element-255">
            <Text fontWeight="bold" color="white" fontSize="sm" data-id="element-256">
              {author}
            </Text>
            <HStack spacing={2} mt={1} data-id="element-257">
              <Text fontSize="sm" color="gray.400" data-id="element-258">
                {location}
              </Text>
              {verified && <Text fontSize="xs" color="green.400" fontWeight="semibold" data-id="element-259">
                  ✅ Compra verificada
                </Text>}
            </HStack>
          </Box>
        </HStack>
      </VStack>
    </Box>;
}